// extracted by mini-css-extract-plugin
export default {"list":"TransactionList_list__-PwHH","emptyTransactionsWrapper":"TransactionList_emptyTransactionsWrapper__Q1UsQ","transactionsWrapper":"TransactionList_transactionsWrapper__cSpg4"};